import {
  breakpointSizes,
  getBreakpointDown,
  styleConstants,
} from '@paywithextend/components'
import { grey450, white100 } from 'ext-ui/style/colors'
import React from 'react'
import styled, { css } from 'styled-components'

export interface LayoutTwoColumnPageProps {
  children?: React.ReactElement
  actionComponent?: React.ReactElement
  detailsComponent?: React.ReactElement
  listComponent?: React.ReactElement
  breadCrumbsAnalytics?: string
  noBorder?: boolean
}

const SideBySideContentWrapper = styled.div`
  display: flex;
  gap: 48px;
  height: 100%;
  width: 100%;

  ${getBreakpointDown(breakpointSizes.SM)(css`
    height: fit-content;
    flex-direction: column;
    gap: 20px;
  `)}
`

const ScrollableFixedContent = styled.div`
  overflow-y: auto;
  height: 100%;
  min-width: 400px;
  width: 400px;
  ${getBreakpointDown(breakpointSizes.SM)(css`
    width: 100%;
    height: auto;
    overflow: visible;
  `)}
`

const BorderDiv = styled.div`
  overflow: visible;
  width: 100%;
  border-radius: ${styleConstants.borderRadius.box};
  border: 1px solid ${grey450};
  flex-shrink: 0;
  padding: 20px;
  max-height: fit-content;
  background-color: ${white100};
`

const FlexibleContent = styled.div`
  flex: 1;
  min-width: 0;
  overflow: visible;

  ${getBreakpointDown(breakpointSizes.SM)(css`
    width: 100%;
  `)}
`

const LayoutTwoColumnPage: React.FC<LayoutTwoColumnPageProps> = ({
  children,
  detailsComponent,
  listComponent,
}) => {
  return (
    <div>
      {children}
      <SideBySideContentWrapper>
        <ScrollableFixedContent>
          <BorderDiv>{detailsComponent}</BorderDiv>
        </ScrollableFixedContent>
        <FlexibleContent>{listComponent}</FlexibleContent>
      </SideBySideContentWrapper>
    </div>
  )
}

export default LayoutTwoColumnPage
